import * as React from 'react';
import { connect } from 'react-redux';

import 'floating-label-react/styles.css';
import FloatingLabel from 'floating-label-react';
import LoginWrapper from './Login.style';
import { 
  Button, 
  Card, 
} from '../../ui';

import {
  clean,
  setStepInnerPage,
} from "../../../actions";
import authActions from '../../../actions/auth';
import { auth } from "../../../operations";

import { validatePassword } from '../../../helpers';

import iconPass from '../../../assets/icons/icon-pass.svg';
import iconAlert from '../../../assets/icons/icon-alert.svg';

class ChangePassword extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false,
      password: '',
      password2: '',
      token: '',
    };

    const { authReset } = this.props;
    authReset();
  }

  componentDidMount() {
    const { ci, rut, setStepInnerPage } = this.props;
    const { password, password2 } = this.state;
    this.checkContinueState({ continue: true }, password !== '' && password !== undefined
      && validatePassword(password, ci, rut) && password === password2);
    
    const token = new URLSearchParams(window.location.search).get('token');
    if(token === null) { setStepInnerPage('login') }
    else { this.setState({ token }) }
  }

  componentDidUpdate(prevProps, prevState) {
    const { ci, rut } = this.props;
    const { password, password2 } = this.state;
    this.checkContinueState(prevState, password !== '' && password !== undefined
      && validatePassword(password, ci, rut) && password === password2);
  }

  getBackButton() {
    const { reset } = this.props;
    return (
      <Button
        plain
        onClick={() => { reset() }}
        className="Password-link"
      >
        Volver al inicio
      </Button>
    );
  }

  getContinueButton() {
    const { continue: isEnabled } = this.state;
    const { isLoading } = this.props;
    
    return (
      <Button
        block
        onClick={this.handleClick}
        disabled={!isEnabled}
        isLoading={isLoading}
      >
        Guardar contraseña
      </Button>
    );
  }

  handleClick = () => {
    const { changePassword, email } = this.props;
    const { token, password, password2 } = this.state;
    if(password === password2) changePassword(token, password);
  };

  checkContinueState(prevState, condition) {
    if (condition) {
      if (!prevState.continue) this.setState({ continue: true });
    } else if (prevState.continue) this.setState({ continue: false });
  }

  render() {
    const { isLoading, result } = this.props;
    const { password, password2, continue: continueVar } = this.state;

    const SUCCESS = result === 'SUCCESS';
    const successMessage = 'Contraseña modificada con éxito';
    const errorPasswords = 'Las contraseñas no coinciden';
    const errorPasswordFormat = `La contraseña proporcionada no es válida.
      Debe contener un largo minimo de 8 caracteres, al menos una mayúscula, 
      una minúscula y un número (0-9), y no contener ni la CI ni el RUT.`;
    
    return (
      <Card className="Card--medium">
        <LoginWrapper>
          <Card.Header className="Password-firsttitle">Cambiar contraseña</Card.Header>

          <div className="Password-inputs">
            <div className="Password-input-line">
              <div className="Password-input-img-container">
                <img className="Password-input-img" alt="" src={iconPass} />
              </div>
              <FloatingLabel
                alt="input"
                id="password"
                name="password"
                placeholder="Nueva contraseña"
                disabled={isLoading || SUCCESS}
                maxLength="50"
                type="password"
                value={password}
                onChange={(event) => { this.setState({ password: event.target.value }); }}
              />
            </div>
            <br />

            <div className="Password-input-line">
              <div className="Password-input-img-container">
                <img className="Password-input-img" alt="" src={iconPass} />
              </div>
              <FloatingLabel
                alt="input"
                id="password2"
                name="password2"
                placeholder="Repetir contraseña"
                maxLength="50"
                disabled={isLoading || SUCCESS}
                type="password"
                value={password2}
                onChange={(event) => { this.setState({ password2: event.target.value }); }}
              />
            </div>
          </div>
          
          <div className="Password-change-message">
            {(password || password2) && !continueVar && !SUCCESS && (
                <div className="Password-error-container">
                  <p className="Password-error">
                    {password !== password2 && errorPasswords}
                    {password === password2 && errorPasswordFormat}
                  </p>
                </div>
              )}
            {result
              && (
                <p className={SUCCESS ? 'Password-success' : 'Password-error'}>
                  {SUCCESS && successMessage}
                  {!SUCCESS && result}
                </p>
              )}
          </div>
          <div className="Password-change-button">
            <div className="Password-buttons-container">
              <React.Fragment>
                {!SUCCESS && this.getContinueButton()}
                {SUCCESS && this.getBackButton()}
              </React.Fragment>
            </div>
          </div>
        </LoginWrapper>
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.auth.isLoading,
  ci: state.auth.ci,
  rut: state.auth.rut,
  password: state.auth.password,
  result: state.auth.result,
  email: state.auth.email,
});


const mapDispatchToProps = dispatch => ({
  reset: () => {
    dispatch(clean());
    let href = window.location.href.split('/');
    href.pop();
    window.location.replace(href.join('/'));
  },
  authReset: () => {
    dispatch(authActions.authReset());
  },
  changePassword: (token, newPassword) => {
    dispatch(authActions.authRequest());
    dispatch(auth.changePassword({ token, newPassword }));
  },
  setStepInnerPage: (page) => {
    dispatch(setStepInnerPage(page));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);